import { createContext, useContext } from 'react'
import { TLeadType } from '../interfaces'
import { useLeadOptions } from '../hooks/useLeadOptions'
import { LeadService } from '@forwardflow/services/LeadService'

/**
 * Where filter rows get their values. By default the organization's Follow Up
 * Boss sources, stages, tags and ponds, and the inquired-property search; a
 * screen that runs without an organization (a no-sign-in preview) provides
 * its own.
 */
export interface IFilterOptionsSource {
   useOptions: (
      field: TLeadType,
      search?: string
   ) => ReturnType<typeof useLeadOptions>
   searchProperties: (query: string, limit: number) => Promise<string[]>
}

const DEFAULT_SOURCE: IFilterOptionsSource = {
   useOptions: useLeadOptions,
   searchProperties: (q, limit) =>
      LeadService.searchInquiredProperties(q, limit),
}

export const FilterOptionsContext =
   createContext<IFilterOptionsSource>(DEFAULT_SOURCE)
export const useFilterOptionsSource = () => useContext(FilterOptionsContext)
